import _slicedToArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import isNil from 'lodash/isNil';

var getChunksFromString = function getChunksFromString(st, chunkSize) {
  return st.match(new RegExp(".{".concat(chunkSize, "}"), 'g'));
};

var convertHexUnitTo256 = function convertHexUnitTo256(hexStr) {
  return parseInt(hexStr.repeat(2 / hexStr.length), 16);
};

var getAlphafloat = function getAlphafloat(a, alpha) {
  if (!isNil(a)) {
    return a / 256;
  }

  if (1 < alpha && alpha <= 100) {
    return alpha / 100;
  }

  if (0 <= alpha && alpha <= 1) {
    return alpha;
  }
};

export var getRGBAvalues = function getRGBAvalues(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var chunkSize = Math.floor((hex.length - 1) / 3);
  var hexArr = getChunksFromString(hex.slice(1), chunkSize) || [];

  var _hexArr$map = hexArr.map(convertHexUnitTo256),
      _hexArr$map2 = _slicedToArray(_hexArr$map, 4),
      r = _hexArr$map2[0],
      g = _hexArr$map2[1],
      b = _hexArr$map2[2],
      a = _hexArr$map2[3];

  return [r, g, b, getAlphafloat(a, alpha)];
};

var hex2rgba = function hex2rgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _getRGBAvalues = getRGBAvalues(hex, alpha),
      _getRGBAvalues2 = _slicedToArray(_getRGBAvalues, 4),
      r = _getRGBAvalues2[0],
      g = _getRGBAvalues2[1],
      b = _getRGBAvalues2[2],
      a = _getRGBAvalues2[3];

  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
};

export default hex2rgba;